<template>
  <div class="form-group">
    <vue-hcaptcha
      v-if="captchaType === H_CAPTCHA_NAME"
      ref="captcha"
      :sitekey="captchaSiteKey"
      @verify="$emit('handle-captcha-response')"
      @error="$emit('handle-captcha-response')"
    />
    <div
      v-else
      :id="captchaId"
      class="mtcaptcha"
    />
  </div>
</template>

<script>
import { MT_CAPTCHA_NAME, H_CAPTCHA_NAME } from '@/constants/auth/captcha'
import VueHcaptcha from '@hcaptcha/vue-hcaptcha'

export default {
  name: 'CaptchaWrapper',

  components: { VueHcaptcha },

  props: {
    captchaId: {
      type: String,
      default: 'login-captcha'
    },
    captchaType: {
      type: String,
      default: MT_CAPTCHA_NAME,
    }
  },

  data() {
    return {
      H_CAPTCHA_NAME,
      MT_CAPTCHA_NAME,
      captchaSiteKey: process.env.VUE_APP_H_CAPTCHA_KEY,
    }
  },

  created () {
    switch (this.captchaType) {
      case H_CAPTCHA_NAME:
        this.$refs?.captcha?.reset()
        break
      default:
        window.mtcaptcha.resetUI()
        window.mtcaptchaConfig.renderQueue.push(this.captchaId)
    }

    window.mtcaptchaConfig.error_callback = this.mtCaptchaErrorCallback
    window.mtcaptchaConfig['verified-callback'] = this.mtCaptchaVerifiedCallback
  },

  methods: {
    mtCaptchaErrorCallback (err) {
      console.log(`Error on getting response from MtCaptcha - ${err}`)
    },

    mtCaptchaVerifiedCallback (resp) {
      this.$emit('handle-captcha-response', resp.verifiedToken)
    }
  }
}
</script>
